<template>
    <div v-if="page_init">
        <div class="football-con">
            <div class="area-tip">
                <div class="column1"><img width="70px" src="../assets/images/2024logo.png"></div>
                <div class="column2">
                    <b style="font-size: .26rem;color: gold">2024 European Championship Events</b><!--2024欧锦赛活动-->
                    <p>Every night from 8 PM to 6 AM, you can participate in a penalty shootout once per hour. Each time, you need to play three games, with a turnover reaching ₱2000.</p><!--每晚8点到凌晨两点，每小时可以参与一次点球，每次需要游戏三次，流水达到p2000-->
                    <p>Each time, the prize is the amount corresponding to the goal area where the ball enters.</p><!--每次奖金就是球进门区域对应的金额-->
                </div>
            </div>
            <div id="field">
                <div class="goal-area goal-top-left">{{currency}}{{goalAreas[0].points}}</div>
                <div class="goal-area goal-top-middle">{{currency}}{{goalAreas[1].points}}</div>
                <div class="goal-area goal-top-right">{{currency}}{{goalAreas[2].points}}</div>
                <div class="goal-area goal-middle-left">{{currency}}{{goalAreas[3].points}}</div>
                <div class="goal-area goal-middle-middle">{{currency}}{{goalAreas[4].points}}</div>
                <div class="goal-area goal-middle-right">{{currency}}{{goalAreas[5].points}}</div>
                <div class="goal-area goal-bottom-left">{{currency}}{{goalAreas[6].points}}</div>
                <div class="goal-area goal-bottom-middle">{{currency}}{{goalAreas[7].points}}</div>
                <div class="goal-area goal-bottom-right">{{currency}}{{goalAreas[8].points}}</div>
                <div id="football"></div>
                <img v-if="football_flag" width="25px" style="margin-left: 150px;margin-top:230px" src="../assets/images/football.png">
            </div>
        </div>
        <div style="height: 1rem;"></div>
        <div class="kick-balln-con"><Button @click="shootPenalty" class="kick-balln">Click To Shoot</Button></div>
        <div v-if="goalScored" style="background-color: #fff;margin-top: 3px">
            <mt-popup class="popup-con" v-model="popupVisible">
                <div class="ch-receive-alert">
                    <div class="ch-tip-title">Congratulations</div>
                    <div class="ch-tip-content">Goal! Get amount {{currency}}{{ currentScore }}!</div>
                    <div class="ch-prize-btn">
                        <Button class="ch-prize-con-btn" type="primary" size="small" @click="closeAward()">
                            Confirm
                        </Button>
                    </div>
                </div>
            </mt-popup>
        </div>

    </div>
</template>

<script>
    import {Button, Popup} from 'mint-ui';
    import 'mint-ui/lib/style.css';
    import {getAreaAmount,startShoot,DebounceBy} from "../api/activity";
    export default {
        name: "Football",
        components: {
            Button,
            'mt-popup': Popup
        },
        data() {
            return {
                page_init: false,
                goalScored: false,
                popupVisible: false,
                football_flag: true,
                currentScore: 0,
                currency: '₱',
                goalAreas: []
                /*goalAreas: [
                    {row: 0, col: 0, points: 10}, // Top left
                    {row: 0, col: 1, points: 5},  // Top middle
                    {row: 0, col: 2, points: 10}, // Top right
                    {row: 1, col: 0, points: 5},  // Middle left
                    {row: 1, col: 1, points: 0},  // Middle middle
                    {row: 1, col: 2, points: 5},  // Middle right
                    {row: 2, col: 0, points: 10}, // Bottom left
                    {row: 2, col: 1, points: 5},  // Bottom middle
                    {row: 2, col: 2, points: 10}  // Bottom right
                ]*/
            }
        },
        mounted() {
            this.getGoalAreas()
        },
        methods: {
            getGoalAreas(){
                let that = this
                getAreaAmount().then(res => {
                    that.goalAreas = res.data
                    that.page_init = true
                }).catch(res => {
                    that.$dialog.toast({mes: res.msg});
                })
            },
            shootPenalty:DebounceBy(function () {
                this.goalScored = false;
                let that = this
                startShoot().then(res => {
                    this.football_flag = false;
                    const num = res.data.num
                    const goalArea = this.goalAreas[num];
                    // const goalArea = this.goalAreas[Math.floor(Math.random() * this.goalAreas.length)];
                    that.currentScore = goalArea.points;

                    const football = document.getElementById('football');
                    football.style.display = 'block';
                    football.style.left = '160px'; // Adjusted for new field width
                    football.style.top = '230px'; // Adjusted for new field height

                    const targetX = goalArea.col * 106.67 + 53.33; // Adjusted for new goal area width
                    const targetY = goalArea.row * 61 + 35.5; // Adjusted for new goal area height

                    that.animateBall(football, targetX, targetY);
                    that.popupVisible = true
                }).catch(res => {
                    that.$dialog.toast({mes: res.msg});
                })

            },3000),
            animateBall(ball, targetX, targetY) {
                let posX = 160; // Adjusted for new starting position
                let posY = 230; // Adjusted for new starting position
                const stepX = (targetX - posX) / 30;
                const stepY = (targetY - posY) / 30;

                const interval = setInterval(() => {
                    posX += stepX;
                    posY += stepY;
                    ball.style.left = posX + 'px';
                    ball.style.top = posY + 'px';

                    if (Math.abs(posX - targetX) < 5 && Math.abs(posY - targetY) < 5) {
                        clearInterval(interval);
                        this.goalScored = true;
                        setTimeout(() => {
                            ball.style.display = 'none';
                            this.football_flag = true
                        }, 500);
                    }
                }, 50);
            },
            closeAward() {
                this.popupVisible = false
            }
        }
    }
</script>

<style scoped>
    .football-con {
        /*border: 1px solid red;*/
        /*background: linear-gradient(to bottom right, blue, #7B68EE, #F8F8FF);*/
        background: #fff;
    }
    .area-tip{
        display: flex;
        background: linear-gradient(to right, #fff,#90EE90,#32CD32,#3CB371);
        color: #F5FFFA;
        font-size: .23rem;
        align-items: center;
        padding: 4px 0 4px 2px;
    }

    .column1 {
        flex: 0 0 20%; /* 固定宽度为20% */
        text-align: center;
    }
    .column2 {
        flex: 1; /* 占据剩余空间 */
    }

    #field {
        width: 320px;
        height: 213px; /* Keep the aspect ratio same as 600x400 */
        /*border: 2px solid #f0ead8;*/
        position: relative;
        margin: 5px auto;


        /*display: inline-block;*/
        background: url('../assets/images/goal.png');
        background-size: 400px 350px; /* 图片按比例缩放以适应容器，不变形 */
        background-repeat: no-repeat; /* 防止图片重复 */
        background-position: center;
    }

    .goal-area {
        width: 33.33%;
        height: 33.33%;
        border: 1px dashed orange;
        position: absolute;

        display: flex;
        justify-content: center;
        align-items: center;
        color: gold;
        /*opacity: .5;*/
    }

    .goal-top-left {
        top: 0;
        left: 0;
        border-top: none;
        border-left: none;
        border-right: none;
        border-bottom: none;
    }

    .goal-top-middle {
        top: 0;
        left: 33.33%;
        border-top: none;
        border-bottom: none;
    }

    .goal-top-right {
        top: 0;
        left: 66.66%;
        border-top: none;
        border-left: none;
        border-right: none;
        border-bottom: none;
    }

    .goal-middle-left {
        top: 33.33%;
        left: 0;
        border-left: none;
        border-right: none;
    }

    .goal-middle-middle {
        top: 33.33%;
        left: 33.33%;
    }

    .goal-middle-right {
        top: 33.33%;
        left: 66.66%;
        border-left: none;
        border-right: none;
    }

    .goal-bottom-left {
        top: 66.66%;
        left: 0;
        border-top: none;
        border-left: none;
        border-right: none;
        border-bottom: none;
    }

    .goal-bottom-middle {
        top: 66.66%;
        left: 33.33%;
        border-top: none;
        border-bottom: none;
    }

    .goal-bottom-right {
        top: 66.66%;
        left: 66.66%;
        border-top: none;
        border-left: none;
        border-right: none;
        border-bottom: none;
    }

    #football {
        width: 40px;
        height: 40px;
        /*background-color: black;*/
        position: absolute;
        border-radius: 50%;
        display: none; /* Initially hidden */

        /*display: inline-block;*/
        background: url('../assets/images/football.gif');
        background-size: contain; /* 图片按比例缩放以适应容器，不变形 */
        background-repeat: no-repeat; /* 防止图片重复 */
        background-position: center;
    }
    .popup-con {
        background: none;
    }
    .ch-receive-alert {
        width: 300px;
        height: 230px;
        background-image: url("../assets/images/cbg06.gif");
        /*background-image: url("https://wimg.588ku.com/gif620/21/06/10/616a48900ff20e575daa8ff690f14583.gif");*/
        background-size: contain;
        /*background-size: 300px 230px;*/
        background-repeat: no-repeat;
        background-position: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .ch-tip-title {
        color: #fff;
        font-weight: bold;
        font-size: .35rem;
        margin-top: 10px;
        text-shadow: 0 0 10px #fff, 0 0 20px #fff, 0 0 30px #fff;
    }

    .ch-tip-content {
        color: gold;
        font-size: .3rem;
        margin-top: 20px;
        text-shadow: 0 0 10px gold, 0 0 20px gold, 0 0 30px gold;
    }

    .ch-prize-btn {
        margin-top: 20px;
    }
    .ch-prize-con-btn{
        background-color: gold;
    }
    .kick-balln-con{
        text-align: center;
    }
    .kick-balln{
        background-color: gold;
        color: #fff;
    }
</style>